export const GET_USER_WISE_BANK_DETAILS = "GET_USER_WISE_BANK_DETAILS";
export const GET_USER_WISE_BANK_DETAILS_SUCCESS =
  "GET_USER_WISE_BANK_DETAILS_SUCCESS";
export const GET_USER_WISE_BANK_DETAILS_FAIL =
  "GET_USER_WISE_BANK_DETAILS_FAIL";
